import React, { Component } from "react";
import {Link} from 'react-router-dom';
import rehabCenter from "../../assets/img/rehab.jpg";

const active = {
  color: "orange"
};

class card extends Component {
  render() {
    return (
      
        

        

       
              <div className='card'>
                <Link to={"/rehab/".concat(this.props.link)}>
                <img src={rehabCenter} className='card-img-top' alt="rehabpic" />
                </Link>
                <div className='card-body'>
                <Link to={"/rehab/".concat(this.props.link)}>
                  <h5 className='card-title'>{this.props.name}</h5>
                  </Link>
                  <div className='card-text'>
                    {/* Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled it to make a
                    type specimen book */}
                    {/* {this.props.about}<br /> */}
                    <h6>Location: {this.props.location}</h6>
                    <h6>Phone Number: {this.props.phno}</h6>
                  </div>
                  <div className='footer'>
                    <span className='fa fa-star fa-lg' style={active} />
                    <span className='fa fa-star fa-lg' style={active} />
                    <span className='fa fa-star fa-lg' style={active} />
                    <span className='fa fa-star fa-lg' style={active} />
                    <span className='fa fa-star fa-lg' />
                    <Link to={`/rehab/${this.props.link}`}>
                      <div className='d-flex flex-row-reverse fas fa-arrow-right fa-lg'>
                      </div></Link>
                  </div>
                </div>
              </div>
            
         
    );
  }
}

export default card;
